import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useDrip = (dripId, versionNumber) => {
    const additional = useQueryRequestParams();
    const params = { drip_id: dripId };
    if (versionNumber != null)
        params.version_number = versionNumber;
    return useQuery({
        queryKey: dripKeys.detail(dripId, versionNumber),
        queryFn: () => axios.get(markUrl('drips/detail/'), {
            ...additional,
            params
        }),
        staleTime: 30_000,
        enabled: dripId > 0,
        refetchInterval: versionNumber != null
            ? false
            : (query) => {
                const status = query.state.data?.data?.status;
                return status === 'ACTIVE' ? 15_000 : false;
            }
    });
};
export default useDrip;
